module.exports = __webpack_public_path__ + "img/clearCart.5c18a16e.png";